// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d2c9148","879":"b2bc69d7"}[chunkId] + ".chunk.js";
};